import { Flex } from 'antd'
import { FC } from 'react'
import styled from 'styled-components'
import PageLayout from '../../../components/page-layout/page-layout'
import { useGetMachinesQuery } from '../../../store/api/machines-api'
import MachinesQueues from './components/machines-queues/machines-queues'
import RewindJobs from './components/rewind-jobs/rewind-jobs'
import { rewinderMachinesQuery } from './constants/query-params'

interface RewindPageProps {}

const RewindPage: FC<RewindPageProps> = () => {
    const { data: machinesData, isLoading: isMachinesLoading } = useGetMachinesQuery(rewinderMachinesQuery)
    const machines = machinesData?.data || []

    return (
        <PageLayout title='Перемотка'>
            <PageContent flex='auto' justify='space-between'>
                <LeftPanel>
                    <RewindJobs machines={machines} />
                </LeftPanel>
                <RightPanel>
                    <MachinesQueues machines={machines} isLoading={isMachinesLoading} />
                </RightPanel>
            </PageContent>
        </PageLayout>
    )
}

export default RewindPage

const PageContent = styled(Flex)`
    height: 100%;
    min-width: 0;
`

const LeftPanel = styled.div`
    display: flex;
    flex: 0 0 49%;
    max-width: 49%;
    min-width: 0;
    height: 100%;
    overflow: hidden;
`

const RightPanel = styled.div`
    flex: 0 0 50%;
    max-width: 50%;
    min-width: 0;
    height: 100%;
    overflow: hidden;
`
